module.exports = __webpack_public_path__ + "static/meta/sqs/2022/layout_metadata.b8fd2b1.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2022/meta/layout_metadata.tsv
// module id = Wq9o
// module chunks = 0